import { Accordion, Checkbox, Flex } from "@components/index";
import type React from "react";
import { useCallback } from "react";

export interface FilterOption {
  value: string;
  label: string | React.ReactNode;
}

interface FilterAccordionProps {
  title: string;
  options: FilterOption[];
  selectedValues: string[];
  onChange: (value: string, checked: boolean) => void;
}

const FilterAccordion: React.FC<FilterAccordionProps> = ({
  title,
  options,
  selectedValues,
  onChange,
}) => {
  const handleChange = useCallback(
    (value: string, checked: boolean) => {
      onChange(value, checked);
    },
    [onChange]
  );

  return (
    <Accordion isOpen title={title}>
      <Flex.Col gap="8px">
        {options.map((option) => (
          <Checkbox
            key={option.value}
            label={option.label}
            checked={selectedValues.includes(option.value)}
            onChange={(e) => handleChange(option.value, e.value)}
            size="lg"
          />
        ))}
      </Flex.Col>
    </Accordion>
  );
};

export default FilterAccordion;
